import { useCallback, useEffect, useState } from "react";
import { IMeta, IPagination } from "../types";
import { useLoaderData } from "react-router-dom";
import { App, TablePaginationConfig } from "antd";

export function usePagination<T = unknown>(
  getData: (...args: any) => Promise<IPagination<T>>,
  params?: any
) {
  const { message } = App.useApp();
  const loader = useLoaderData();

  const [filter, setFilter] = useState<any>(loader);
  const [data, setData] = useState<T[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [load, setLoad] = useState(true);
  const [meta, setMeta] = useState<IMeta>({
    current_page: 1,
    per_page: 10,
  });

  const handleRefreshData = () => {
    setLoad(!load);
  };

  const handlePagination = useCallback(
    async (page: number, perPage: number) => {
      setIsLoading(true);
      getData(page, perPage, filter)
        .then(({ data, meta }) => {
          if (meta.last_page < meta.current_page) {
            handlePagination(meta.last_page, meta.per_page);
          }
          setData(data);
          setMeta(meta);
        })
        .catch((error) => {
          if (error.response.status === 403) {
            message.error(
              "Desculpe! no momento você não tem permissão para isso."
            );
          } else {
            console.log(error);
          }
        })
        .finally(() => setIsLoading(false));
    },
    [filter, message, getData]
  );

  useEffect(() => {
    handlePagination(meta.current_page, meta.per_page);
  }, [handlePagination, load, meta.current_page, meta.per_page]);

  const pagination: TablePaginationConfig = {
    position: ["bottomCenter"],
    showSizeChanger: true,
    pageSizeOptions: [5, 10, 20],
    current: meta.current_page,
    pageSize: meta.per_page,
    total: meta.total,
    showTotal: (total, range) =>
      `${range[0]}-${range[1]} de ${total} registros`,
    onChange: handlePagination,
  };

  return {
    data,
    isLoading,
    meta,
    pagination,
    filter,
    setFilter,
    handlePagination,
    handleRefreshData,
  };
}
